import { useState, useEffect, useCallback } from "react";
import { useAuth } from "contexts/AuthContext";
import { API_BASE } from "config/api";

export default function useAccountingReportData() {
  const { user, church } = useAuth();

  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [report, setReport] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchReport = useCallback(
    async (overrides = {}) => {
      if (!user || !church) return;
      try {
        setIsLoading(true);
        const token = localStorage.getItem("authToken");
        if (!token) return;

        const effectiveFrom = "from" in overrides ? overrides.from : from;
        const effectiveTo = "to" in overrides ? overrides.to : to;
        const params = new URLSearchParams();
        if (effectiveFrom) params.set("from", effectiveFrom);
        if (effectiveTo) params.set("to", effectiveTo);

        const response = await fetch(
          `${API_BASE}/accounting/report/${church.id}?${params.toString()}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const result = await response.json();
        setReport(result.data || result);
        setError(null);
      } catch (err) {
        console.error("Failed to fetch accounting report:", err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    },
    [user, church, from, to]
  );

  useEffect(() => {
    fetchReport();
  }, [user, church]);

  const handleApplyFilter = () => fetchReport();

  const handleClearFilter = () => {
    setFrom("");
    setTo("");
    fetchReport({ from: "", to: "" });
  };

  const applyDateRange = (newFrom, newTo) => {
    setFrom(newFrom);
    setTo(newTo);
    fetchReport({ from: newFrom, to: newTo });
  };

  return {
    report,
    isLoading,
    error,
    from,
    setFrom,
    to,
    setTo,
    handleApplyFilter,
    handleClearFilter,
    applyDateRange,
  };
}
